import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => {
    return {
        gridContainer: {
            marginTop: theme.spacing(2)
        },
        showActionsOnHover: {
            '& td:last-of-type *': {
                visibility: 'hidden'
            },
            '&:hover td:last-of-type *': {
                visibility: 'visible'
            }
        },
        selected: {
            background: theme.palette.action.selected,
            '& td:last-of-type *': {
                visibility: 'visible',
            }
        },
    }
}, { index: 1 });